import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <footer
      className="mt-32"
      style={{ borderTop: "0.5px solid rgba(26,26,26,0.35)", backgroundColor: "#F5F0E8" }}
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10 md:gap-14">
          {!isHome && (
            <div className="md:col-span-7">
              <p className="eyebrow mb-6" style={{ color: "rgba(26,26,26,0.55)" }}>
                Let&apos;s talk
              </p>
              <h2
                className="serif-display text-5xl sm:text-6xl lg:text-7xl"
                data-testid="footer-cta-heading"
              >
                Have a brand worth <span className="serif-italic">building?</span>
              </h2>
              <Link
                to="/contact"
                className="inline-flex items-baseline gap-3 mt-10 font-serif text-2xl md:text-3xl editorial-link"
                data-testid="footer-cta-contact"
              >
                <span className="serif-italic">write to shivani</span>
                <span aria-hidden>→</span>
              </Link>
            </div>
          )}

          <div className={`grid grid-cols-2 gap-8 content-end ${isHome ? "md:col-span-12" : "md:col-span-5"}`}>
            <div>
              <p className="eyebrow mb-4" style={{ color: "rgba(26,26,26,0.55)" }}>
                Studio
              </p>
              <ul className="space-y-2 text-[0.95rem]">
                <li>
                  <Link to="/work" className="editorial-link">Work</Link>
                </li>
                <li>
                  <Link to="/services" className="editorial-link">Services</Link>
                </li>
                <li>
                  <Link to="/about" className="editorial-link">About</Link>
                </li>
                <li>
                  <Link to="/process" className="editorial-link">Process</Link>
                </li>
                <li>
                  <Link to="/testimonials" className="editorial-link">Testimonials</Link>
                </li>
                <li>
                  <Link to="/contact" className="editorial-link">Contact</Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="eyebrow mb-4" style={{ color: "rgba(26,26,26,0.55)" }}>
                Elsewhere
              </p>
              <ul className="space-y-2 text-[0.95rem]">
                <li><a href="mailto:shivanisharma.mktg@gmail.com" className="editorial-link">Email</a></li>
                <li><a href="https://www.instagram.com/itsshivaniiiiiiiiiiii/" target="_blank" rel="noreferrer" className="editorial-link">Instagram</a></li>
                <li><a href="https://www.linkedin.com/in/shivanisharma-marketing/" target="_blank" rel="noreferrer" className="editorial-link">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="rule mt-20" />
        <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="flex items-baseline gap-3">
            <span className="serif-display text-3xl md:text-4xl leading-none">Shivani</span>
            <span className="text-[0.7rem] tracking-[0.22em] uppercase font-sans" style={{ color: "rgba(26,26,26,0.55)" }}>
              Brand Strategist
            </span>
          </div>
          <p className="text-[0.7rem] tracking-[0.18em] uppercase font-sans" style={{ color: "rgba(26,26,26,0.55)" }}>
            © {new Date().getFullYear()} Work with Shivani · All rights, slowly built.
          </p>
        </div>
      </div>
    </footer>
  );
}
